import { render } from "./horizontal-header.vue?vue&type=template&id=9896b110"
import script from "./horizontal-header.vue?vue&type=script&lang=js"
export * from "./horizontal-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__